<template><div>
    <slot><div>Название поля</div></slot>
    <div class="mydates-wrap">

<!--
is-multiple - показывать два месяца
format - все без ведущих нулей
isAutoCloseable - закрывать по выбору
enabledDates -  даты на которых можно выбирать
-->

        <functional-calendar ref="cale"
            class="dates"
            :is-modal="true" :is-date-range="true" :calendars-count="2" :is-multiple="true"
            :dateFormat="format"
            :enabledDates="enabledDates"
            :dayNames="dayNames"
            :monthNames="monthNames"
            :shortMonthNames="shortMonthNames"
            :value="vals"
            @input="select"
            @closed="closed"
            :isAutoCloseable="true"
        >
          <template v-slot:dateRangeInputs="props" class="start_end_text">
            <div class="start_end_text">
                <vCalendar class="ico-calend vicon-black" />
                <div :class="{empty:!props.startDate && !props.endDate}">{{ start_end_text( props.startDate, props.endDate ) }}<span class="hi">---</span></div>
            </div>
          </template>
        </functional-calendar>

        <button v-if="props.choosed[0]"   title="Сбросить" class="clear" @click.stop.prevent="clean" ><vRemove class="icon-red" /></button>
        
    </div>
</div></template>

<style lang="scss" src="./MyDates.scss"></style>

<script setup>
import {ref, computed, unref} from 'vue'
import { FunctionalCalendar } from "vue-functional-calendar"
import vRemove from '@/assets/vicons/remove.vue'
import vCalendar from '@/assets/vicons/calendar2.vue'
import dayjs from 'dayjs'

const cale = ref()

const props = defineProps({
  list: Array, 
  choosed: Array,
  placeholder: {type: String, default: 'выбрать'},
})
const emits = defineEmits([ 'input' ])

const closed = () => {
    let {$el} = unref(cale)
    if ($el) {
        $el.blur()
    }
}

const clean = () => {
    emits('input', ['',''])
}

const start_end_text = (start, endin) => {
    let ret=''
    let end = endin
    if (start && !endin && props.list.length) {
        end = props.list[ props.list.length - 1 ]
    }

    if (!start && !end) {
        ret = props.placeholder
    } else if (!end) {
        let dtext = dayjs( md2ymd( start )  ).format('DD.MM.YY')
        ret = `${dtext} и далее`
    } else if (start === end) {
        let dtext = dayjs( md2ymd( start )  ).format('DD.MM.YY')
        ret = `${dtext}`
    } else {
        let dtext1 = dayjs( md2ymd( start )  ).format('DD.MM.YY')
        let dtext2 = dayjs( md2ymd( end )  ).format('DD.MM.YY')
        ret = `${dtext1} — ${dtext2}`
    }
    return ret
}

const vals = computed( () => {
    let dateRange = {start: '', end : ''}
    if (props.choosed) {
        let [start, end] = props.choosed
        start = ymd2md( start )
        end = ymd2md( end )
        dateRange = {start, end}
    }
    return { dateRange }
} )


const select = (all) => {
    const start = md2ymd(all.dateRange.start)
    const end = md2ymd(all.dateRange.end)
//    console.log('select', start, end)
    emits('input', [start,end])
//    emits.
}

const format = 'yyyy/mm/dd'


const ymd2md = d => d.replace(/-0?/g,'/')
const md2ymd = (d)=> {
    let a = d.split('/')
    let ret = a.map( s => 1 === s.length ?  `0${s}` : s  ).join('-')
    return ret
}

const enabledDates=computed( () => {
    return props.list.map( ymd2md  )
} )

const dayNames = ["Пн", "Вт","Ср","Чт","Пт","Сб","Вс" ]
const monthNames = [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ]
const shortMonthNames = monthNames

</script>